// eslint-disable-next-line no-unused-vars
import React from "react";
import "./Style.css";
import { Helmet } from 'react-helmet';

import cl27 from "../../assets/cl27.png";
import cl28 from "../../assets/cl28.png";
import cl29 from "../../assets/cl29.png";
import cl30 from "../../assets/cl30.png";
import cl31 from "../../assets/cl31.png";
import cl32 from "../../assets/cl32.png";
import cl33 from "../../assets/cl33.png";
import cl34 from "../../assets/cl34.png";

import logo from "../../assets/navlogo.png";

import "swiper/css/bundle";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import "swiper/css/effect-coverflow";
import "swiper/css/navigation";

function Traitements() {
  const handleReservationClick = () => {
    console.log("Reservation button clicked!");
    // Add navigation or other logic here
  };
  return (
    <div className="Traitements">
    <Helmet>
    <title>Traitements Dentaires - Excellence Centre Dentaire</title>
    <meta name="description" content="Découvrez nos différents traitements dentaires proposés à l'Excellence Centre Dentaire. De l'implantation dentaire à l'orthodontie invisible, nous offrons des solutions personnalisées pour tous vos besoins." />
    <meta name="keywords" content="traitements dentaires, implants, orthodontie, esthétique dentaire, parodontologie, Ngaous, Batna, Algérie" />
  </Helmet>
      <div className="Traitements-container1">
      <div className="hidden-text">
      <h1>dentiste setif</h1>
      <h1>dentiste Algerie</h1>
      <h1>dentiste N'gaous</h1>
      <h1>dentiste Ngaous</h1>
      <h1>dentiste Ngaous Batna</h1>
      <h1>dentiste Biskra</h1>
      <h1>dentiste Batna</h1>
      <h1>dentiste Khenchlaa</h1>
      <h1>dentiste Constantine</h1>
      <h1>dentiste Oum El Bouaghi</h1>
      <h1>dentiste ngaous </h1>
      <h1>dentiste Batna</h1>
      <h1>dentiste M'sila</h1>
      <h1>dentiste Msila</h1>
      <h1>dentiste Alger</h1>
      <h1>dentiste Algerie</h1>
      <h1>soins dentaires</h1>
      <h1>orthodontie, implants, esthétique dentaire, chirurgie orale, blanchiment, hygiène dentaire, urgence dentaire, Algérie</h1></div>
        <img src={cl27} alt="Traitements" />
        <div className="Traitements-container11">
          <div className="Traitements-text">
            <h1>Notre équipe</h1>
            <h2>EXCELLENCE CENTRE DENTAIRE</h2>
          </div>
        </div>
      </div>
      <div className="Traitements-container2">
        <div className="Traitements-caption">
          <h3>
            “Des soins dentaires personnalisés et innovantsNous offrons une
            gamme complète de
            <br /> traitements alliant expertise et technologies de pointe pour
            sublimer votre sourire.”
          </h3>
        </div>
      </div>
      <div className="Traitements-container3">
        <h1>Les implants dentaires</h1>
        <div className="Traitements-container31">
          <div className="Traitements-container31-img">
            <img src={cl28} alt="Traitements" />
          </div>
          <div className="Traitements-container31-text">
            <p>
              L’implantologie dentaire permet de remplacer des dents, mais ce
              n’est pas seulement un acte esthétique. Cela permet aussi de
              retrouver un bien-être certain aux patients souffrant de la perte
              d’une ou plusieurs dents.
            </p>
            <h3>
              <span>Définition</span> d’un implant dentaire
            </h3>
            <p>
              Un implant dentaire est comme une petite vis, c’est une racine
              artificielle, il est en titane et biocompatible. Il sert à
              remplacer la racine d’une dent abîmée ou manquante et permet de
              servir de point d’ancrage à une future prothèse dentaire ou
              couronne céramique. Que ce soit pour une ou plusieurs dents
              manquantes nous vous proposerons la solution la mieux adaptée à
              votre cas, pour un résultat optimal à la fois esthétique et fiable
              dans le temps. Grâce à l’implant dentaire, votre nouvelle dent
              aura l’apparence et l’efficacité d’une dent naturelle saine.
            </p>
          </div>
        </div>
      </div>

      <div className="Traitements-container4">
        <h1>L'esthétique en dentisterie</h1>
        <div className="Traitements-container41">
          <div className="Traitements-container41-text">
            <p>
              L’esthétique dentaire regroupe l’ensemble des techniques
              permettant d’avoir de jolies dents. Une belle dentition est
              souvent l’expression d’un certain statut social. La couleur des
              dents peut évoluer suite à une maladie, à des prises de
              médicaments au vieillissement ou tout simplement selon votre
              patrimoine génétique. La forme de la dentition, l’implantation
              dentaire peut avoir subi des agressions, ou n’être pas idéale
              médicalement parlant. Selon votre souhait, nous pouvons vous
              proposer des solutions dans 95% des cas, sans chirurgie lourde,
              pour retrouver confort et esthétique selon vos souhaits.
            </p>
          </div>
          <div className="Traitements-container41-img">
            <img src={cl29} alt="Traitements" />
          </div>
        </div>
      </div>
      <div className="Traitements-container5">
        <h1>L'orthodontie invisible</h1>
        <div className="Traitements-container51">
          <div className="Traitements-container51-img">
            <img src={cl30} alt="Traitements" />
          </div>
          <div className="Traitements-container51-text">
            <p>
              Ce traitement d’orthodontie invisible déplace les dents à l’aide
              de gouttières amovibles transparentes. Réalisées sur mesure,
              celles-ci sont préparées à partir d’un logiciel spécialisé qui
              permet de visualiser les mouvements dentaires désirés. Les dents
              ne déplacent progressivement à chaque changement de gouttière. Un
              traitement orthodontique est souvent refusé par les patients
              adultes, car le port de bagues en métal est difficilement
              compatible avec leur vie sociale, et plus encore avec leur vie
              professionnelle. Il leur est maintenant possible de conserver
              l’esthétique de leur sourire pendant la durée du traitement. Cette
              procédure est valable pour différents types de malpositions
              dentaires et peut être utilisée pour les adultes comme pour les
              adolescents.
            </p>
          </div>
        </div>
      </div>
      <div className="Traitements-container6">
        <h1>La parodontologie</h1>
        <div className="Traitements-container6-row1">
          <div className="Traitements-container6-row1-card">
            <div className="Traitements-container6-row1-text">
              <h3>01. La Gingivite</h3>
              <p>
                Pour conserver des dents saines, il est essentiel d’assurer
                également la santé de vos gencives et de supprimer les dépôts de
                tartre sous-gingivaux.
              </p>
            </div>
            <div className="Traitements-container6-row1-img">
              <img src={cl31} alt="Traitements" />
            </div>
          </div>
          <div className="card-line"></div>
          <div className="Traitements-container6-row1-card">
            <div className="Traitements-container6-row1-text">
              <h3>02 La Parodontite Débutante</h3>
              <p>
                Une inflammation non soignée peut endommager votre dentition
                durablement. Pour ne pas en arriver là, nous mettons en place
                des soins adaptés destinés à enrayer le processus et à préserver
                durablement la santé de vos dents.
              </p>
            </div>
            <div className="Traitements-container6-row1-img">
              <img src={cl32} alt="Traitements" />
            </div>
          </div>
        </div>
        <div className="container6-line">
          <div className="container6-line1"></div>
          <div className="container6-line1"></div>
        </div>
        <div className="Traitements-container6-row1">
          <div className="Traitements-container6-row1-card">
            <div className="Traitements-container6-row1-text">
              <h3>03 La Parodontite Modérée</h3>
              <p>
                Les maladies parodontales ou parodontites sont des infections
                bactériennes qui se manifestent par des saignements gingivaux,
                des rétractions de la gencive et une perte osseuse autour de la
                dent pouvant être à l’origine de mobilités dentaires.
              </p>
            </div>
            <div className="Traitements-container6-row1-img">
              <img src={cl33} alt="Traitements" />
            </div>
          </div>
          <div className="card-line"></div>
          <div className="Traitements-container6-row1-card">
            <div className="Traitements-container6-row1-text">
              <h3>04 La Parodontite Avancée</h3>
              <p>
                La plaque dentaire et le tartre sont les facteurs déclenchants
                de la maladie parodontale puisqu’ils servent de support aux
                bactéries à l’origine de ce phénomène.
              </p>
            </div>
            <div className="Traitements-container6-row1-img">
              <img src={cl34} alt="Traitements" />
            </div>
          </div>
        </div>
      </div>
      <div className="Traitements-container7">
        <h1>Autres Services:</h1>
        <ul class="Traitements-container7-text">
          <li>Consultations et extractions sans rendez-vous</li>
          <li>Chirurgie dentaire et pose d’implants</li>
          <li>
            Laboratoire numérique (planification implantaire / conception
            assistée par ordinateur)
          </li>
          <li>Consultations spécialisées</li>
          <li>Blanchiment et esthétique dentaire</li>
          <li>
            Radiographie panoramique et CBCT (Cone Beam Computed Tomography)
          </li>
        </ul>
      </div>

      <div className="Traitements-container8">
        <h3>
          Prise en charge des douleurs dentaires urgentes et traitements
          immédiats
        </h3>
        <a
          href="https://wa.me/213663535252"
          target="_blank"
          rel="noopener noreferrer"
        >
          <button
            className="reservation-buttom-urgent"
            onClick={handleReservationClick}
          >
            <p>Prenez votre rendez-vous</p>
          </button>
        </a>
      </div>

      <div className="footer">
              <div className="footer-container1">
                <h2>N'hésitez pas à nous rendre visite à tout moment</h2>
                <div className="footer-container11">
                  <div className="footer-infos">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="33"
                      height="33"
                      viewBox="0 0 33 33"
                      fill="none"
                    >
                      <circle cx="16.3027" cy="16.5801" r="16" fill="#3167D9" />
                      <path
                        d="M16.1881 8.90039C14.5216 8.90228 12.9239 9.56514 11.7455 10.7435C10.5671 11.9219 9.90423 13.5197 9.90234 15.1862C9.90234 20.5648 15.6167 24.627 15.8603 24.797C15.9563 24.8643 16.0708 24.9004 16.1881 24.9004C16.3054 24.9004 16.4199 24.8643 16.516 24.797C16.7596 24.627 22.4739 20.5648 22.4739 15.1862C22.472 13.5197 21.8092 11.9219 20.6307 10.7435C19.4523 9.56514 17.8546 8.90228 16.1881 8.90039ZM16.1881 12.9004C16.6402 12.9004 17.0821 13.0345 17.458 13.2856C17.8339 13.5368 18.1269 13.8938 18.2999 14.3115C18.4729 14.7291 18.5181 15.1887 18.4299 15.6321C18.3417 16.0755 18.124 16.4828 17.8044 16.8024C17.4847 17.1221 17.0774 17.3398 16.634 17.428C16.1907 17.5162 15.7311 17.4709 15.3134 17.2979C14.8957 17.1249 14.5388 16.8319 14.2876 16.4561C14.0364 16.0802 13.9024 15.6382 13.9024 15.1862C13.9024 14.58 14.1432 13.9986 14.5719 13.5699C15.0005 13.1412 15.5819 12.9004 16.1881 12.9004Z"
                        fill="white"
                      />
                    </svg>
                    <p>N’GAOUS, BATNA, ALGERIE</p>
                  </div>
                  <div className="footer-infos">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="33"
                      height="33"
                      viewBox="0 0 33 33"
                      fill="none"
                    >
                      <circle cx="16.4346" cy="16.5801" r="16" fill="#3167D9" />
                      <path
                        d="M16.4346 8.58008C12.0165 8.58008 8.43457 12.162 8.43457 16.5801C8.43457 20.9982 12.0165 24.5801 16.4346 24.5801C20.8526 24.5801 24.4346 20.9982 24.4346 16.5801C24.4346 12.162 20.8526 8.58008 16.4346 8.58008ZM20.1269 17.8108H16.4346C16.2714 17.8108 16.1148 17.746 15.9994 17.6306C15.884 17.5152 15.8192 17.3587 15.8192 17.1955V11.657C15.8192 11.4938 15.884 11.3373 15.9994 11.2219C16.1148 11.1065 16.2714 11.0416 16.4346 11.0416C16.5978 11.0416 16.7543 11.1065 16.8697 11.2219C16.9851 11.3373 17.05 11.4938 17.05 11.657V16.5801H20.1269C20.2901 16.5801 20.4466 16.6449 20.562 16.7603C20.6774 16.8757 20.7423 17.0323 20.7423 17.1955C20.7423 17.3587 20.6774 17.5152 20.562 17.6306C20.4466 17.746 20.2901 17.8108 20.1269 17.8108Z"
                        fill="white"
                      />
                    </svg>
                    <p>
                      Tous les jours <br />
                      De 08.00 a 18.00
                    </p>
                  </div>
                  <div className="footer-infos">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="33"
                      height="33"
                      viewBox="0 0 33 33"
                      fill="none"
                    >
                      <circle cx="16.5664" cy="16.5801" r="16" fill="#3167D9" />
                      <path
                        d="M26.5662 12.1152V21.5801C26.5663 22.3453 26.2739 23.0816 25.7489 23.6384C25.224 24.1951 24.5061 24.5302 23.7422 24.5751L23.5662 24.5801H9.56638C8.80117 24.5802 8.06488 24.2878 7.50814 23.7628C6.9514 23.2379 6.6163 22.52 6.57141 21.7561L6.56641 21.5801V12.1152L16.0113 18.4122L16.1273 18.4782C16.264 18.545 16.4142 18.5797 16.5663 18.5797C16.7185 18.5797 16.8686 18.545 17.0053 18.4782L17.1213 18.4122L26.5662 12.1152Z"
                        fill="white"
                      />
                      <path
                        d="M23.5656 8.58008C24.6456 8.58008 25.5926 9.15007 26.1206 10.0071L16.5656 16.377L7.01074 10.0071C7.26147 9.59984 7.60595 9.25847 8.01544 9.01146C8.42493 8.76444 8.88756 8.61893 9.36472 8.58708L9.56572 8.58008H23.5656Z"
                        fill="white"
                      />
                    </svg>
                    <p>
                      CLINIQUEEXCELLENCE
                      <br />
                      @gmail.cm
                    </p>
                  </div>
                  <div className="footer-infos">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="33"
                      height="33"
                      viewBox="0 0 33 33"
                      fill="none"
                    >
                      <circle cx="16.6973" cy="16.5801" r="16" fill="#3167D9" />
                      <path
                        d="M23.7639 24.5801C21.8528 24.5801 19.99 24.154 18.1755 23.3019C16.361 22.4497 14.7536 21.3238 13.3533 19.9241C11.953 18.5244 10.827 16.917 9.97549 15.1019C9.12393 13.2867 8.69786 11.4239 8.69727 9.51341C8.69727 9.24674 8.78615 9.02452 8.96393 8.84674C9.14171 8.66897 9.36393 8.58008 9.6306 8.58008H13.2306C13.438 8.58008 13.6232 8.64674 13.7862 8.78008C13.9491 8.91341 14.0454 9.08378 14.075 9.29119L14.6528 12.4023C14.6825 12.6097 14.6786 12.7987 14.6413 12.9694C14.6039 13.1401 14.5189 13.2918 14.3862 13.4245L12.2528 15.6023C12.875 16.669 13.6528 17.669 14.5862 18.6023C15.5195 19.5356 16.5491 20.343 17.675 21.0245L19.7639 18.9356C19.8973 18.8023 20.0715 18.7024 20.2866 18.6361C20.5017 18.5697 20.7127 18.551 20.9195 18.5801L23.9862 19.2023C24.1936 19.2467 24.3639 19.3469 24.4973 19.5027C24.6306 19.6586 24.6973 19.8399 24.6973 20.0467V23.6467C24.6973 23.9134 24.6084 24.1356 24.4306 24.3134C24.2528 24.4912 24.0306 24.5801 23.7639 24.5801Z"
                        fill="white"
                      />
                    </svg>
                    <p>
                      +213663 535 252
                      <br />
                      +213 333 775 00
                    </p>
                  </div>
                </div>
              </div>
              <div className="footer-container2">
                <div className="footer-element1">
                  <img src={logo} alt="Accueil" />
                </div>
                <div className="footer-element2">
                  <ul id="menuList">
                    <li>
                      <a href="#Accueil" className="font-semibold pb-6">
                        Accueil
                      </a>
                    </li>
                    <li>
                      <a href="#Equipe" className="font-semibold">
                        Clinique
                      </a>
                    </li>
                    <li>
                      <a href="#Clinique" className="font-semibold">
                        Equipe
                      </a>
                    </li>
                    <li>
                      <a href="#Aboutus" className="font-semibold">
                        Traitements
                      </a>
                    </li>
                    <li>
                      <a href="#contact" className="font-semibold">
                        Contact
                      </a>
                    </li>
                  </ul>
                </div>
                <div className="footer-element3">
                  <div className="footer-element31">
                  <a
                  href="https://www.google.com/maps/place/EXCELLENCE+centre+dentaire/@35.5534458,5.6058517,17z/data=!4m6!3m5!1s0x12f48f7f30de532d:0x72e472485b169e53!8m2!3d35.5534458!4d5.6085307!16s%2Fg%2F11rfsbk5q6?coh=225993&entry=tts&g_ep=EgoyMDI1MDEyMi4wIPu8ASoASAFQAw%3D%3D"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="32"
                        height="33"
                        viewBox="0 0 32 33"
                        fill="none"
                      >
                        <circle cx="16" cy="16.5" r="16" fill="#3167D9" />
                        <path
                          d="M22.3641 8.63606C24.0164 10.2882 24.9614 12.5182 24.9993 14.8545C25.0372 17.1908 24.1649 19.4502 22.5671 21.1551L22.3641 21.3651L18.1211 25.6071C17.5827 26.1451 16.8599 26.4584 16.0992 26.4834C15.3385 26.5085 14.5967 26.2435 14.0241 25.7421L13.8801 25.6071L9.63606 21.3641C7.94822 19.6762 7 17.387 7 15.0001C7 12.6131 7.94822 10.3239 9.63606 8.63606C11.3239 6.94822 13.6131 6 16.0001 6C18.387 6 20.6762 6.94822 22.3641 8.63606ZM16.0001 12.0001C15.6061 12.0001 15.216 12.0777 14.852 12.2284C14.488 12.3792 14.1573 12.6002 13.8787 12.8787C13.6002 13.1573 13.3792 13.488 13.2284 13.852C13.0777 14.216 13.0001 14.6061 13.0001 15.0001C13.0001 15.394 13.0777 15.7841 13.2284 16.1481C13.3792 16.5121 13.6002 16.8428 13.8787 17.1214C14.1573 17.4 14.488 17.6209 14.852 17.7717C15.216 17.9225 15.6061 18.0001 16.0001 18.0001C16.7957 18.0001 17.5588 17.684 18.1214 17.1214C18.684 16.5588 19.0001 15.7957 19.0001 15.0001C19.0001 14.2044 18.684 13.4413 18.1214 12.8787C17.5588 12.3161 16.7957 12.0001 16.0001 12.0001Z"
                          fill="white"
                        />
                      </svg>
                    </a>
                  </div>
                  <div className="footer-element31">
                    <a href="https://www.instagram.com/dr_khaled_harous/" target="_blank"
                    rel="noopener noreferrer">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="32"
                        height="33"
                        viewBox="0 0 32 33"
                        fill="none"
                      >
                        <circle cx="16" cy="16.5" r="16" fill="#3167D9" />
                        <path
                          d="M16.7197 9.50086C17.2305 9.4989 17.7413 9.50403 18.252 9.51626L18.3878 9.52116C18.5446 9.52676 18.6993 9.53376 18.8862 9.54216C19.6309 9.57716 20.1391 9.69475 20.585 9.86765C21.047 10.0454 21.4362 10.2862 21.8254 10.6754C22.1812 11.0251 22.4566 11.4482 22.6324 11.9151C22.8053 12.361 22.9229 12.8698 22.9579 13.6146C22.9663 13.8008 22.9733 13.9562 22.9789 14.113L22.9831 14.2488C22.9956 14.7592 23.0009 15.2698 22.9992 15.7803L22.9999 16.3025V17.2195C23.0017 17.7303 22.9963 18.2411 22.9838 18.7517L22.9796 18.8875C22.974 19.0443 22.967 19.199 22.9586 19.3859C22.9236 20.1307 22.8046 20.6389 22.6324 21.0848C22.4572 21.5522 22.1817 21.9756 21.8254 22.3251C21.4754 22.6809 21.0521 22.9563 20.585 23.1322C20.1391 23.3051 19.6309 23.4227 18.8862 23.4577C18.6993 23.4661 18.5446 23.4731 18.3878 23.4787L18.252 23.4829C17.7413 23.4953 17.2305 23.5007 16.7197 23.499L16.1976 23.4997H15.2813C14.7705 23.5014 14.2597 23.496 13.749 23.4836L13.6132 23.4794C13.4471 23.4734 13.2809 23.4664 13.1149 23.4584C12.3701 23.4234 11.8619 23.3044 11.4153 23.1322C10.9482 22.9567 10.5251 22.6813 10.1757 22.3251C9.81941 21.9753 9.54374 21.552 9.36789 21.0848C9.195 20.6389 9.0774 20.1307 9.0424 19.3859C9.03461 19.2198 9.02761 19.0537 9.0214 18.8875L9.0179 18.7517C9.005 18.2411 8.99916 17.7303 9.0004 17.2195V15.7803C8.99845 15.2698 9.00358 14.7592 9.0158 14.2488L9.0207 14.113C9.0263 13.9562 9.0333 13.8008 9.0417 13.6146C9.0767 12.8691 9.1943 12.3617 9.36719 11.9151C9.54315 11.4479 9.81935 11.025 10.1764 10.6761C10.5256 10.3197 10.9484 10.0437 11.4153 9.86765C11.8619 9.69475 12.3694 9.57716 13.1149 9.54216L13.6132 9.52116L13.749 9.51766C14.2595 9.50476 14.77 9.49893 15.2806 9.50016L16.7197 9.50086ZM16.0002 13.0007C15.5364 12.9942 15.076 13.0799 14.6457 13.2528C14.2154 13.4257 13.8237 13.6824 13.4934 14.008C13.1632 14.3337 12.901 14.7217 12.722 15.1495C12.543 15.5773 12.4508 16.0365 12.4508 16.5003C12.4508 16.964 12.543 17.4232 12.722 17.851C12.901 18.2789 13.1632 18.6669 13.4934 18.9925C13.8237 19.3181 14.2154 19.5748 14.6457 19.7478C15.076 19.9207 15.5364 20.0064 16.0002 19.9998C16.9284 19.9998 17.8186 19.6311 18.475 18.9747C19.1313 18.3184 19.5 17.4281 19.5 16.4999C19.5 15.5717 19.1313 14.6815 18.475 14.0251C17.8186 13.3688 16.9284 13.0007 16.0002 13.0007ZM16.0002 14.4007C16.2791 14.3956 16.5563 14.4461 16.8155 14.5492C17.0747 14.6524 17.3108 14.8062 17.5099 15.0017C17.709 15.1971 17.8671 15.4302 17.9751 15.6875C18.0831 15.9447 18.1387 16.2209 18.1388 16.4999C18.1388 16.7789 18.0833 17.0551 17.9754 17.3124C17.8675 17.5697 17.7094 17.8029 17.5104 17.9984C17.3113 18.1939 17.0753 18.3478 16.8161 18.451C16.557 18.5543 16.2798 18.6049 16.0009 18.5999C15.4439 18.5999 14.9098 18.3786 14.516 17.9848C14.1222 17.591 13.9009 17.0569 13.9009 16.4999C13.9009 15.943 14.1222 15.4089 14.516 15.015C14.9098 14.6212 15.4439 14.4 16.0009 14.4L16.0002 14.4007ZM19.675 11.9508C19.4492 11.9598 19.2357 12.0559 19.0791 12.2188C18.9225 12.3818 18.8351 12.599 18.8351 12.825C18.8351 13.051 18.9225 13.2683 19.0791 13.4312C19.2357 13.5942 19.4492 13.6903 19.675 13.6993C19.9071 13.6993 20.1297 13.6071 20.2937 13.443C20.4578 13.279 20.55 13.0564 20.55 12.8243C20.55 12.5923 20.4578 12.3697 20.2937 12.2057C20.1297 12.0416 19.9071 11.9494 19.675 11.9494V11.9508Z"
                          fill="white"
                        />
                      </svg>
                    </a>
                  </div>
                  <div className="footer-element31">
                    <a href="https://www.facebook.com/excellencecentredentaire/" target="_blank"
                    rel="noopener noreferrer">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="32"
                        height="33"
                        viewBox="0 0 32 33"
                        fill="none"
                      >
                        <circle cx="16" cy="16.5" r="16" fill="#3167D9" />
                        <path
                          d="M16.9 17.55H18.65L19.35 14.75H16.9V13.35C16.9 12.629 16.9 11.95 18.3 11.95H19.35V9.598C19.1218 9.5679 18.2601 9.5 17.3501 9.5C15.4496 9.5 14.1 10.6599 14.1 12.79V14.75H12V17.55H14.1V23.5H16.9V17.55Z"
                          fill="white"
                        />
                      </svg>
                    </a>
                  </div>
                  <div className="footer-element31">
                    <a href="https://wa.me/213663535252"
                    target="_blank"
                    rel="noopener noreferrer">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="32"
                        height="33"
                        viewBox="0 0 32 33"
                        fill="none"
                      >
                        <circle cx="16" cy="16.5" r="16" fill="#3167D9" />
                        <path
                          d="M16 9.5C19.8661 9.5 23 12.6339 23 16.5C23 20.3661 19.8661 23.5 16 23.5C14.763 23.502 13.5477 23.1746 12.479 22.5515L9.00281 23.5L9.94921 20.0224C9.32557 18.9534 8.99794 17.7376 9.00001 16.5C9.00001 12.6339 12.1339 9.5 16 9.5ZM13.6144 13.21L13.4744 13.2156C13.3838 13.2211 13.2952 13.2449 13.214 13.2856C13.1381 13.3286 13.0688 13.3824 13.0082 13.4452C12.9242 13.5243 12.8766 13.5929 12.8255 13.6594C12.5666 13.996 12.4272 14.4093 12.4293 14.834C12.4307 15.177 12.5203 15.5109 12.6603 15.8231C12.9466 16.4545 13.4177 17.123 14.0393 17.7425C14.1891 17.8916 14.3361 18.0414 14.4943 18.1807C15.2667 18.8607 16.1871 19.3511 17.1823 19.6129L17.5799 19.6738C17.7094 19.6808 17.8389 19.671 17.9691 19.6647C18.173 19.6542 18.372 19.599 18.5522 19.503C18.6439 19.4558 18.7333 19.4044 18.8203 19.349C18.8203 19.349 18.8504 19.3294 18.9078 19.286C19.0023 19.216 19.0604 19.1663 19.1388 19.0844C19.1969 19.0242 19.2473 18.9535 19.2858 18.873C19.3404 18.7589 19.395 18.5412 19.4174 18.3599C19.4342 18.2213 19.4293 18.1457 19.4272 18.0988C19.4244 18.0239 19.3621 17.9462 19.2942 17.9133L18.8868 17.7306C18.8868 17.7306 18.2778 17.4653 17.9054 17.2959C17.8664 17.2789 17.8247 17.2692 17.7822 17.2672C17.7343 17.2623 17.6859 17.2677 17.6403 17.283C17.5946 17.2983 17.5528 17.3233 17.5176 17.3561C17.5141 17.3547 17.4672 17.3946 16.9611 18.0078C16.9321 18.0468 16.892 18.0763 16.8462 18.0925C16.8003 18.1087 16.7506 18.1109 16.7035 18.0988C16.6579 18.0866 16.6132 18.0711 16.5698 18.0526C16.483 18.0162 16.4529 18.0022 16.3934 17.977C15.9917 17.8017 15.6197 17.5648 15.2909 17.2749C15.2027 17.1979 15.1208 17.1139 15.0368 17.0327C14.7614 16.769 14.5214 16.4706 14.3228 16.1451L14.2815 16.0786C14.2518 16.0339 14.2279 15.9857 14.2101 15.9351C14.1835 15.8322 14.2528 15.7496 14.2528 15.7496C14.2528 15.7496 14.4229 15.5634 14.502 15.4626C14.579 15.3646 14.6441 15.2694 14.6861 15.2015C14.7687 15.0685 14.7946 14.932 14.7512 14.8263C14.5552 14.3475 14.3522 13.8708 14.1436 13.3976C14.1023 13.3038 13.9798 13.2366 13.8685 13.2233C13.8307 13.2191 13.7929 13.2149 13.7551 13.2121C13.6611 13.2074 13.5669 13.2084 13.473 13.2149L13.6137 13.2093L13.6144 13.21Z"
                          fill="white"
                        />
                      </svg>
                    </a>
                  </div>
                </div>
              </div>
            </div>
    </div>
  );
}

export default Traitements;
